//import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { projects } from '../data/projects';
import { Link } from 'react-router-dom';

export default class Details extends Component {
  state = {
    projeto: null,
  }
  componentDidMount() {
    this.filterProject();
  };

  filterProject = ( ) => {
    //const {location: {  pathname  }} = this.props;
    // const title = pathname.replace(/\//g, '');
    const { match: { params: { id } } } = this.props;
    const project = projects.find(project => project.title === id);
    this.setState({ projeto: project });
    console.log('aqui esta o project', this.state.projeto);

  };

  render() {
    const { projeto } = this.state;
    return (
      <div>
          {/* <Link to="/">
            <button>Voltar</button>
          </Link> */}
          {projeto.length > 0  && (
          <div>
            <h1>{projeto.title}</h1>
            <img src={projeto.img} alt={projeto.title} />
            <p>{projeto.description}</p>
            {projeto.tecnologies.map((tecnology, index) => (
              <div key={index}>
                <p>{tecnology}</p>
              </div>
            ))}
            <a className="btn-repo" href={projeto.reposotorio} rel="noreferrer" target="_blank">Repositorio</a>
          <a className="btn-deploy" href={projeto.deploy} target="_blank" rel="noreferrer">Deploy</a>
          </div>
          )}
      </div>
    )
  };
};
